<template>
  <div class="material">
    <!-- 材料内容 -->
    <div class="material-content" v-if="subtopicInfo.material" :style="{paddingBottom: subtopicInfo.type * 1 === 2 ? '0.6rem' : '0.1rem'}">
      <p v-html="subtopicInfo.material"></p>
    </div>
    <!-- 素材容器 -->
    <div class="materials-container" :class="{flip: flipStatus, center: !subtopicInfo.material}">
      <div class="tabs" v-if="subtopicInfo.r_material.length > 0 && subtopicInfo.t_material.length > 0">
        <div class="tab-item" :class="{active: tabsValue === item.value}" v-for="item in tabsList" :key="item.value" @click="tabsChange(item.value)">
          <p>{{ item.label }}</p>
        </div>
      </div>
      <!-- 参照素材 -->
      <div class="refer-material" v-if="tabsValue === 1 || subtopicInfo.t_material.length === 0">
        <div class="material-list" :class="`num${subtopicInfo.r_material.length}`">
          <template v-if="subtopicInfo.r_type * 1 === 1">
            <div class="image" v-for="(item, index) in subtopicInfo.r_material" :key="index">
              <img :src="item.img_url" />
            </div>
          </template>
          <template v-if="subtopicInfo.r_type * 1 === 2">
            <div class="video" v-for="(item, index) in subtopicInfo.r_material" :key="index" @click="playVideo(item.img_url)">
              <div class="preview">
                <img src="@/assets/img/video-preview.png" />
              </div>
              <div class="icon">
                <img src="@/assets/img/btn-play.png" alt=""></img>
              </div>
            </div>
          </template>
          <template v-if="subtopicInfo.r_type * 1 === 3">
            <div class="audio" v-for="(item, index) in subtopicInfo.r_material" :key="index" @click="togglePlay(index)">
              <div class="player">
                <div class="wave-wrapper left" :class="{ active: isPlaying[index] }">
                  <div class="wave-bar" v-for="i in 10" :key="i"></div>
                </div>
                <div class="player-btn">
                  <span class="icon iconfont icon-yinpin"></span>
                </div>
                <div class="wave-wrapper right" :class="{ active: isPlaying[index] }">
                  <div class="wave-bar" v-for="i in 10" :key="i"></div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- 测试素材 -->
      <div class="test-material" v-if="tabsValue === 2 || subtopicInfo.r_material.length === 0">
        <div class="material-list" :class="`num${subtopicInfo.t_material.length}`">
          <template v-if="subtopicInfo.t_type * 1 === 1">
            <div class="image" v-for="(item, index) in subtopicInfo.t_material" :key="index">
              <img :src="item.img_url" />
            </div>
          </template>
          <template v-if="subtopicInfo.t_type * 1 === 2">
            <div class="video" v-for="(item, index) in subtopicInfo.t_material" :key="index" @click="playVideo(item.img_url)">
              <div class="preview">
                <img src="@/assets/img/video-preview.png" />
              </div>
              <div class="icon">
                <img src="@/assets/img/btn-play.png" alt=""></img>
              </div>
            </div>
          </template>
          <template v-if="subtopicInfo.t_type * 1 === 3">
            <div class="audio" v-for="(item, index) in subtopicInfo.t_material" :key="index" @click="togglePlay(index)">
              <div class="player">
                <div class="wave-wrapper left" :class="{ active: isPlaying[index] }">
                  <div class="wave-bar" v-for="i in 10" :key="i"></div>
                </div>
                <div class="player-btn">
                  <span class="icon iconfont icon-yinpin"></span>
                </div>
                <div class="wave-wrapper right" :class="{ active: isPlaying[index] }">
                  <div class="wave-bar" v-for="i in 10" :key="i"></div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 选项 -->
    <div class="options" v-if="subtopicInfo.type * 1 === 2" :style="{bottom: `${subtopicInfo.t_content?'0.6':'0.2'}rem`}">
      <div class="option-item" :class="{active: getSelectedStatus(item.key)}" v-for="(item, index) in subtopicInfo.many.option" :key="item.key" @click="optionSelect(item, index)">{{ item.content }}</div>
    </div>
    <!-- 测试内容 -->
    <div class="test-content" v-if="subtopicInfo.t_content">
      <div class="label" @click="contentShowHide">
        <p>测试内容</p>
        <van-icon name="arrow-down" />
      </div>
      <div class="content" v-show="contentShow">
        <p v-html="subtopicInfo.t_content"></p>
      </div>
    </div>
    <div class="flip-btn" v-if="!subtopicInfo.material && (subtopicInfo.r_type * 1 === 1 || subtopicInfo.t_type * 1 === 1)" @click="flip">
      <img src="@/assets/img/btn-flip.png" alt="">
    </div>
    <!-- 视频播放弹窗 -->
    <div class="video-modal" v-show="videoVisible">
      <div class="mask" @click="closeVideo"></div>
      <div class="video-container">
        <video ref="videoPlayer" :src="currentVideoUrl" controls autoplay></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "material",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    subtopicInfo: {
      type: Object,
      required: true
    },
    originalSubtopicInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      flipStatus: false,
      answer: "",
      answerRecord: [],
      isShow: false,
      contentShow: false,
      tabsList: [
        { label: '参照素材', value: 1 },
        { label: '测试素材', value: 2 }
      ],
      tabsValue: 1,
      isPlaying: [], // 用于存储每个音频的播放状态
      audioPlayer: null, // 全局音频播放器
      currentPlayingIndex: -1, // 当前播放的音频索引
      currentPlayingType: '', // 当前播放的素材类型 'refer' 或 'test'
      videoVisible: false, // 控制视频弹窗显示
      currentVideoUrl: '',
    }
  },
  watch: {
    value: {
      handler(val) {
        this.answer = val;
      },
      immediate: true
    },
    subtopicInfo: {
      handler(val) {
        if (val.material) {
          val.material = this.txtTransform(val.material)
        }
        if (val.t_content) {
          val.t_content = this.txtTransform(val.t_content)
        }
        if (this.originalSubtopicInfo.is_rec * 1 === 1) {
          this.answer = this.originalSubtopicInfo.rec_answer * 1;
          this.$emit('input', this.answer);
          this.$set(this, 'answerRecord', this.originalSubtopicInfo.rec_option);
        }
      },
      immediate: true
    }
  },
  methods: {
    txtTransform(str) {
      return str.replace(/\n/g, "<br>");
    },
    tabsChange(value) {
      if (this.tabsValue != value) {
        this.tabsValue = value;
        this.stopAudio();
      }
    },
    contentShowHide() {
      this.contentShow = !this.contentShow
    },
    flip() {
      this.flipStatus = !this.flipStatus
    },
    // 初始化音频播放器
    initAudioPlayer() {
      if (!this.audioPlayer) {
        this.audioPlayer = new Audio();
        this.audioPlayer.addEventListener('ended', () => {
          this.audioEnded();
        });
      }
    },
    // 处理音频播放结束
    audioEnded() {
      if (this.currentPlayingIndex !== -1) {
        this.$set(this.isPlaying, this.currentPlayingIndex, false);
        this.currentPlayingIndex = -1;
        this.currentPlayingType = '';
      }
    },

    // 停止音频播放
    stopAudio() {
      if (this.audioPlayer) {
        this.audioPlayer.pause();
        this.audioPlayer.currentTime = 0;
        if (this.currentPlayingIndex !== -1) {
          this.$set(this.isPlaying, this.currentPlayingIndex, false);
          this.currentPlayingIndex = -1;
          this.currentPlayingType = '';
        }
      }
    },

    // 切换音频播放状态
    togglePlay(index) {
      this.initAudioPlayer();

      const currentType = this.tabsValue === 1 || this.subtopicInfo.t_material.length === 0 ? 'refer' : 'test';
      const audioList = currentType === 'refer' ? this.subtopicInfo.r_material : this.subtopicInfo.t_material;

      // 如果点击的是当前正在播放的音频
      if (this.currentPlayingIndex === index && this.currentPlayingType === currentType) {
        if (this.audioPlayer.paused) {
          // 继续播放
          this.audioPlayer.play();
          this.$set(this.isPlaying, index, true);
        } else {
          // 暂停播放
          this.audioPlayer.pause();
          this.$set(this.isPlaying, index, false);
        }
        return;
      }

      // 停止当前播放的音频
      if (this.currentPlayingIndex !== -1) {
        this.$set(this.isPlaying, this.currentPlayingIndex, false);
      }

      // 播放新的音频
      this.audioPlayer.src = audioList[index].img_url;
      this.audioPlayer.play();
      this.$set(this.isPlaying, index, true);
      this.currentPlayingIndex = index;
      this.currentPlayingType = currentType;
    },
    // 播放视频
    playVideo(url) {
      this.currentVideoUrl = url;
      this.videoVisible = true;
    },

    // 关闭视频
    closeVideo() {
      this.videoVisible = false;
      this.currentVideoUrl = '';
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },
    optionSelect(item, index) {
      let existIndex = this.answerRecord.findIndex(i => i.key * 1 === item.key * 1)
      if (existIndex !== -1) {
        this.answerRecord.splice(existIndex, 1)
      } else {
        this.answerRecord.push(item)
      }
      this.calculateAnswer()
    },
    getSelectedStatus(value) {
      return this.answerRecord.some(v => v.key * 1 === value * 1);
    },
    // 计算分数
    calculateAnswer() {
      if (this.answerRecord.length === 0) {
        this.answer = '';
      } else {
        if (this.subtopicInfo.type * 1 === 2) {
          let correct = this.subtopicInfo.many.answer
          let isAllCorrect = this.answerRecord.every(v => correct.some(v2 => v2.key * 1 === v.key * 1))
          if (correct.length === this.answerRecord.length && isAllCorrect) {
            this.answer = 1;
          } else {
            this.answer = 0;
          }
        }
      }
      this.$emit('input', this.answer);
    },
  },
  beforeDestroy() {
    // 组件销毁前停止播放并释放资源
    if (this.audioPlayer) {
      this.stopAudio();
      this.audioPlayer = null;
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
}
.material {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.15rem 0.2rem;
  overflow-y: scroll;
  .material-content {
    font-size: 0.16rem;
    color: #630200;
    line-height: 1.8;
  }
  .materials-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    &.center {
      justify-content: center;
    }
    &.flip {
      transform: rotate(180deg);
    }
    .tabs {
      width: fit-content;
      background: #ffe9cf;
      border-radius: 0.5rem;
      padding: 0.08rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      margin: 0 auto;

      .tab-item {
        border-radius: 0.15rem;
        text-align: center;
        line-height: 0.3rem;
        font-size: 0.14rem;
        color: #484848;
        padding: 0 0.1rem;

        &.active {
          background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
          color: #ffffff;
        }
      }
    }
    .material-title {
      font-size: 0.18rem;
      font-weight: bold;
      color: #630200;
      text-align: center;
    }
    .material-list {
      display: flex;
      justify-content: center;
      margin-top: 0.1rem;
      // 图片
      .image {
        width: 2.6rem;
        height: 2.6rem;
        border-radius: 0.1rem;
        margin: 0 0.17rem;
        overflow: hidden;
        img {
          object-fit: cover;
        }
      }
      &.num3 .image {
        width: 2rem;
        height: 2rem;
        margin: 0 0.15rem;
      }
      &.num4 .image {
        width: 1.5rem;
        height: 1.5rem;
        margin: 0 0.08rem 0.16rem;
      }
      &.num5 {
        flex-wrap: wrap;
        .image {
          width: 1.5rem;
          height: 1.5rem;
          margin: 0 0.05rem 0.16rem;
        }
      }
      // 视频
      .video {
        width: 2.5rem;
        aspect-ratio: 16/9;
        border-radius: 0.1rem;
        position: relative;
        .preview {
          width: 100%;
          height: 100%;
          border-radius: 0.2rem;
          overflow: hidden;
        }
        .icon {
          width: 0.4rem;
          height: 0.4rem;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, 50%);
        }
      }
      &.num2 .video {
        width: 2.4rem;
        margin: 0 0.17rem;
        .icon {
          width: 0.36rem;
          height: 0.36rem;
        }
      }
      &.num3 .video {
        width: 2rem;
        margin: 0 0.15rem;
        .icon {
          width: 0.4rem;
          height: 0.4rem;
        }
      }
      &.num4 .video {
        width: 1.6rem;
        margin: 0 0.08rem;
        .icon {
          width: 0.26rem;
          height: 0.26rem;
        }
      }
      &.num5 {
        padding: 0 0.25rem;
        flex-wrap: wrap;
        .video {
          width: 1.9rem;
          margin: 0 0.08rem 0.25rem;
          .icon {
            width: 0.26rem;
            height: 0.26rem;
          }
        }
      }
      // 音频
      .audio {
        width: 3rem;
        background: linear-gradient(
          314deg,
          #fff6e5 0%,
          #ffebd4 97%,
          #ffebd4 100%
        );
        border-radius: 0.8rem;
        margin: 0.07rem;
        position: relative;
        padding: 0 0.24rem;
        .player {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.12rem 0;
          .wave-wrapper {
            display: flex;
            align-items: center;

            &.left {
              margin-right: 0.1rem;
            }

            &.right {
              margin-left: 0.1rem;
            }

            .wave-bar {
              width: 0.02rem;
              height: 0.14rem;
              background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
              margin: 0 0.015rem;
              border-radius: 0.01rem;

              &:nth-child(5n + 1) {
                height: 0.06rem;
              }
              &:nth-child(5n + 2) {
                height: 0.14rem;
              }
              &:nth-child(5n + 3) {
                height: 0.2rem;
              }
              &:nth-child(5n + 4) {
                height: 0.14rem;
              }
              &:nth-child(5n + 5) {
                height: 0.06rem;
              }
            }

            &.active .wave-bar {
              animation: waveAnimation 1s ease-in-out infinite;

              &:nth-child(5n + 1) {
                animation-delay: 0s;
              }
              &:nth-child(5n + 2) {
                animation-delay: 0.2s;
              }
              &:nth-child(5n + 3) {
                animation-delay: 0.4s;
              }
              &:nth-child(5n + 4) {
                animation-delay: 0.6s;
              }
              &:nth-child(5n + 5) {
                animation-delay: 0.8s;
              }
            }
          }
          &-btn {
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            border: 0.03rem solid #fff8df;
            box-shadow: 0 0.02rem 0.05rem 0.01rem #fc652a;
            background: linear-gradient(180deg, #ffb81d 0%, #fb750f 100%);
            display: flex;
            justify-content: center;
            align-items: center;
            .iconfont {
              font-size: 0.22rem;
              color: #fff3c6;
            }
          }
        }
        .name {
          font-size: 0.14rem;
          color: #630200;
          line-height: 0.3rem;
          text-align: center;
        }
      }
      &.num3 .audio {
        width: 2.2rem;
        padding: 0 0.2rem;
        .wave-wrapper .wave-bar {
          height: 0.14rem;
          margin: 0 0.015rem;

          &:nth-child(5n + 1) {
            height: 0.04rem;
          }
          &:nth-child(5n + 2) {
            height: 0.12rem;
          }
          &:nth-child(5n + 3) {
            height: 0.18rem;
          }
          &:nth-child(5n + 4) {
            height: 0.12rem;
          }
          &:nth-child(5n + 5) {
            height: 0.04rem;
          }
        }
        .player-btn {
          width: 0.3rem;
          height: 0.3rem;
          border: 0.02rem solid #fff8df;
          .iconfont {
            font-size: 0.16rem;
            color: #fff3c6;
          }
        }
        .name {
          font-size: 0.14rem;
          line-height: 0.3rem;
        }
      }
      &.num4 .audio {
        width: 2rem;
        padding: 0 0.15rem;
        .wave-wrapper .wave-bar {
          height: 0.14rem;
          margin: 0 0.01rem;

          &:nth-child(5n + 1) {
            height: 0.04rem;
          }
          &:nth-child(5n + 2) {
            height: 0.12rem;
          }
          &:nth-child(5n + 3) {
            height: 0.18rem;
          }
          &:nth-child(5n + 4) {
            height: 0.12rem;
          }
          &:nth-child(5n + 5) {
            height: 0.04rem;
          }
        }
        .player-btn {
          width: 0.3rem;
          height: 0.3rem;
          border: 0.02rem solid #fff8df;
          .iconfont {
            font-size: 0.16rem;
            color: #fff3c6;
          }
        }
        .name {
          font-size: 0.14rem;
          line-height: 0.3rem;
        }
      }
      &.num5 {
        flex-wrap: wrap;
        .audio {
          width: 2.1rem;
          .wave-wrapper .wave-bar {
            height: 0.14rem;
            margin: 0 0.01rem;

            &:nth-child(5n + 1) {
              height: 0.04rem;
            }
            &:nth-child(5n + 2) {
              height: 0.12rem;
            }
            &:nth-child(5n + 3) {
              height: 0.18rem;
            }
            &:nth-child(5n + 4) {
              height: 0.12rem;
            }
            &:nth-child(5n + 5) {
              height: 0.04rem;
            }
          }
          .player-btn {
            width: 0.3rem;
            height: 0.3rem;
            border: 0.02rem solid #fff8df;
            .iconfont {
              font-size: 0.16rem;
              color: #fff3c6;
            }
          }
          .name {
            font-size: 0.14rem;
            line-height: 0.3rem;
          }
        }
      }
    }
  }

  .switch-btn {
    width: 1rem;
    height: 0.3rem;
    background: url("~@/assets/img/confirm-btn1.png") center center / 100% 100%
      no-repeat;
    color: #630200;
    font-weight: bold;
    font-size: 0.16rem;
    text-align: center;
    line-height: 0.3rem;
    cursor: pointer;
    margin: 0.1rem auto 0;
  }
  .test-content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    .label {
      width: 1.2rem;
      height: 0.5rem;
      background: #ffe37d;
      box-shadow: 0 0 0.06rem 0.01rem #ffcb0e,
        inset 0 0.03rem 0.06rem 0.01rem #ff845a;
      border-radius: 0.3rem 0.3rem 0 0;
      font-size: 0.16rem;
      font-weight: bold;
      color: #630200;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 0.1rem;
      position: relative;
      left: 80%;
      .van-icon {
        font-size: 0.12rem;
        color: #f59f0c;
        margin-top: 0.02rem;
      }
    }
    .content {
      background: linear-gradient(
        143deg,
        #ffe0cf 0%,
        #fffde1 46%,
        #ffd8c5 100%
      );
      border-radius: 0 0 0.2rem 0.2rem;
      font-size: 0.14rem;
      color: #630200;
      line-height: 1.8;
      border-top: 0.04rem solid #ffc8a9;
      padding: 0.2rem 0.3rem;
      min-height: 1.2rem;
      max-height: 50vh;
      overflow-y: scroll;
    }
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background: linear-gradient(124deg, #fff6e5 0%, #ffebd4 100%);
    box-shadow: 0 0.03rem 0.06rem 1px rgba(216, 130, 0, 0.38);
    border-radius: 0.16rem;
    border: 1px dashed #ffb453;
    padding: 0.06rem;
    width: 96%;
    position: absolute;
    bottom: 0.6rem;
    left: 50%;
    transform: translateX(-50%);
    .option-item {
      width: 15.3%;
      line-height: 0.3rem;
      border-radius: 0.15rem;
      text-align: center;
      background: #fff;
      font-size: 0.14rem;
      color: #630200;
      margin: 0 0.6%;
      &.active {
        background: linear-gradient(180deg, #ffe56f 0%, #ffd100 100%);
      }
    }
  }
  .flip-btn {
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
    width: 0.28rem;
    height: 0.28rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
@keyframes waveAnimation {
  0% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.5);
  }
  100% {
    transform: scaleY(1);
  }
}
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .video-container {
    position: relative;
    width: 60%;
    aspect-ratio: 16/9;
    z-index: 1000;
    font-size: 0;

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #000;
      border-radius: 0.1rem;
    }
  }
}
</style>